import { render, staticRenderFns } from "./CouponCreateEditModal.vue?vue&type=template&id=2312e664&"
import script from "./CouponCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./CouponCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports